import React from 'react';
import {QueryClientProvider} from '@tanstack/react-query';
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import {queryClient} from './lib/query/queryClient';
import {AuthProvider} from './contexts/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import FirebaseServiceProvider from './components/auth/FirebaseServiceProvider';
import Layout from './components/layout/Layout';
import AuthenticatedLayout from './components/layout/AuthenticatedLayout';
import UnauthenticatedLayout from './components/layout/UnauthenticatedLayout';
import SettingsLayout from './components/layout/SettingsLayout';
import CoursesPage from "@/features/courses/pages/CoursesPage.tsx";
import PomodoroPage from "@/features/pomodoro/pages/PomodoroPage.tsx";
import ProjectsPage from "@/features/projects/pages/ProjectsPage.tsx";
import OneTimersPage from "@/features/oneTimers/pages/OneTimersPage.tsx";
import ProfileSettingsPage from "@/features/settings/pages/ProfileSettingsPage.tsx";
import SecuritySettingsPage from "@/features/settings/pages/SecuritySettingsPage.tsx";
import PreferencesSettingsPage from "@/features/settings/pages/PreferencesSettingsPage.tsx";
import SignInPage from "@/features/auth/pages/SignInPage.tsx";
import SignUpPage from "@/features/auth/pages/SignUpPage.tsx";
import ForgotPasswordPage from "@/features/auth/pages/ForgotPasswordPage.tsx";
import NotFoundPage from "./pages/NotFoundPage";

const App: React.FC = () => {
    return (
        <AuthProvider>
            <QueryClientProvider client={queryClient}>
                <Router>
                    <FirebaseServiceProvider>
                        <Routes>
                            {/* Unauthenticated Routes */}
                            <Route element={<UnauthenticatedLayout />}>
                                <Route path="/signin" element={<SignInPage />} />
                                <Route path="/signup" element={<SignUpPage />} />
                                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            </Route>
                            
                            {/* Protected Routes */}
                            <Route path="/*" element={
                                <ProtectedRoute>
                                    <Layout>
                                        <AuthenticatedLayout>
                                            <Routes>
                                                <Route path="/" element={<Navigate to="/courses" replace/>}/>
                                                <Route path="courses" element={<CoursesPage/>}/>
                                                <Route path="pomodoro" element={<PomodoroPage/>}/>
                                                {/*<Route path="projects" element={<ProjectsPage/>}/>*/}
                                                <Route path="tasks" element={<OneTimersPage/>}/>
                                                <Route path="settings/*" element={<SettingsLayout/>}>
                                                    <Route index element={<Navigate to="profile" replace/>}/>
                                                    <Route path="profile" element={<ProfileSettingsPage/>}/>
                                                    <Route path="security" element={<SecuritySettingsPage/>}/>
                                                    <Route path="preferences" element={<PreferencesSettingsPage/>}/>
                                                </Route>
                                                <Route path="*" element={<NotFoundPage/>}/>
                                            </Routes>
                                        </AuthenticatedLayout>
                                    </Layout>
                                </ProtectedRoute>
                            }/>
                        </Routes>
                    </FirebaseServiceProvider>
                </Router>
            </QueryClientProvider>
        </AuthProvider>
    );
};

export default App;
